import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import Vuex from 'vuex'
import store from './store/index'
import vuetify from './plugins/vuetify'
import VueObserveVisibility from 'vue-observe-visibility';
import footer from './components/Footer'

Vue.component('Footer', footer)

document.title = 'Memories For Us';

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueObserveVisibility)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
